import type { Formatters } from '@/shared/i18n/format';
import { toDate, type DateInput } from '@/shared/i18n/format';

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * "только что" · "5 минут назад" · "вчера" · "через 3 дня" · and an absolute date beyond a week.
 * Pure function of (`value`, `now`) so it can be unit-tested and rendered without impure calls.
 */
export function formatRelative(
  value: DateInput,
  now: number,
  fmt: Pick<Formatters, 'intlLocale' | 'date'>,
  justNow: string,
): string {
  const date = toDate(value);
  const diff = date.getTime() - now;
  const abs = Math.abs(diff);
  if (abs < 45_000) return justNow;
  const rtf = new Intl.RelativeTimeFormat(fmt.intlLocale, { numeric: 'auto' });
  if (abs < HOUR) return rtf.format(Math.round(diff / MINUTE), 'minute');
  if (abs < DAY) return rtf.format(Math.round(diff / HOUR), 'hour');
  if (abs < 7 * DAY) return rtf.format(Math.round(diff / DAY), 'day');
  return new Date(now).getFullYear() === date.getFullYear()
    ? fmt.date(date, 'dateShort')
    : fmt.date(date, 'dateLong');
}
